import {
  Image,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  Button,
  DropdownItem,
} from '@nextui-org/react';
import React, { useEffect, Fragment, useState } from 'react';
import { addTopic, getAllTopics } from '../../services/querys ';
import AddTopicModal from '../../components/Modal/AddTopicModal';
import ApprovalModal from '../../components/Modal/ApprovalModal';
import { message } from 'antd';
import moment from 'moment';
import {
  useInfiniteQuery,
  useQueryClient,
  useMutation,
} from '@tanstack/react-query';
import { useInView } from 'react-intersection-observer';
import Loading from '../../components/Loading/Loading';
import { useNavigate } from 'react-router-dom';
import { MdAppRegistration } from 'react-icons/md';
import { decryptData } from '../../utils/encryptData';
import { useSelector } from 'react-redux';
import ErrorBoundary from '../../utils/Errorboundary';

function Topics() {
  const [selectedKeys, setSelectedKeys] = useState('approved');
  const { ref, inView } = useInView();
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const { uid, rl } = useSelector((state) => state.auth);
  const loggedInUserId = decryptData(uid);
  const role = decryptData(rl);

  //get all post using infinite scrolling
  const { data, isFetchingNextPage, fetchNextPage } = useInfiniteQuery({
    queryKey: ['topics', selectedKeys],
    queryFn: async ({ pageParam }) => getAllTopics({ pageParam, selectedKeys }),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      return lastPage.length ? allPages.length + 1 : undefined;
    },
  });

  useEffect(() => {
    if (inView) {
      fetchNextPage();
    }
  }, [fetchNextPage, inView]);

  //add topics
  const { mutate: createTopic, isPending } = useMutation({
    mutationFn: addTopic,
    onError: (error) => {
      console.error('Error adding post:', error);
      message.error(error.message);
    },
    onSuccess: async () => {
      message.success('Topic added successfully');
      await queryClient.invalidateQueries(['topics']);
    },
  });

  const submitForm = async (formData) => {
    createTopic(formData);
  };

  const handelNavigate = (id) => {
    console.log('id: ', id);
    navigate(`/community/topics/${id}`);
  };

  const handleSelect = (key) => {
    setSelectedKeys(key);
  };

  return (
    <>
      <div className="mt-8 sm:mt-[75px] font-poppins">
        <div className="grid gris-cols-2">
          <h2 className="text-2xl flex font-bold text-gray-200">Topics</h2>

          <div className="flex justify-end items-center">
            {role === 'admin' && (
              <Dropdown>
                <DropdownTrigger>
                  <Button
                    endContent={
                      <MdAppRegistration className="text-btn-color" size={15} />
                    }
                    variant="bordered"
                    className={`text-md font-poppins border ${selectedKeys === 'approved' ? 'border-btn-color text-white' : 'border-yellow-500 text-yellow-500'} font-normal  mr-5`}
                  >
                    {selectedKeys === 'approved' ? 'Approved' : 'Pending'}
                  </Button>
                </DropdownTrigger>
                <DropdownMenu
                  color="success"
                  aria-label="Static Actions"
                  onAction={handleSelect}
                >
                  <DropdownItem key="approved">Approved</DropdownItem>
                  <DropdownItem key="pending">Pending</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            )}

            {(role === 'admin' || role === 'user') && (
              <AddTopicModal onPress={submitForm} />
            )}
          </div>
        </div>

        <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 ">
          {data?.pages.map((page, pageIndex) => (
            <Fragment key={pageIndex}>
              {page?.map((topic, index) => (
                <Card
                  onPress={
                    selectedKeys === 'approved'
                      ? () => handelNavigate(topic?.topicId)
                      : ''
                  }
                  isPressable
                  isFooterBlurred
                  className="w-full h-[300px] "
                >
                  <CardHeader className="absolute z-10 flex-col bg-black/40 items-start border-b-1 border-default-700">
                    <p className="text-tiny text-white/60 uppercase font-bold">
                      {' '}
                      {moment(topic?.createdAt).fromNow()} | by editor
                    </p>
                    <h4 className="text-white/90 font-medium text-xl line-clamp-2 text-start">
                      {' '}
                      #{topic?.title}
                    </h4>
                  </CardHeader>
                  <Image
                    isZoomed
                    removeWrapper
                    alt="Relaxing app background"
                    className="z-0 w-full h-full object-cover"
                    src={topic?.image[0]?.url || '/img/test.png'}
                  />
                  <CardFooter className="absolute bg-black/40 bottom-0 z-10 border-t-1 border-default-600 dark:border-default-100">
                    <div className="flex flex-grow gap-2 items-center">
                      <div className="flex flex-col">
                        <p className="text-md text-white/60 line-clamp-3 text-start">
                          {topic?.description}
                        </p>
                      </div>
                    </div>

                    {selectedKeys === 'pending' && (
                      <ApprovalModal id={topic?.topicId} />
                    )}
                  </CardFooter>
                </Card>
              ))}
            </Fragment>
          ))}
          {/* one */}
        </div>
      </div>

      {/* Loading */}
      <div ref={ref} className="my-8">
        {isFetchingNextPage ? <Loading isLoading={isFetchingNextPage} /> : null}
      </div>
    </>
  );
}

export default Topics;
